export const identity = (arg) => arg;

export const mapArguments = (mapper, fn) => (...args) =>
  fn(...args.map(mapper));
